import { useParams } from 'react-router-dom';
import Logo from '../../../../assets/images/brand/only-logo.png';
import { Button } from '../../../components/atoms/Button';
import { Typography } from '../../../components/molecules/Typography';
import { Breadcrumbs } from '../../../components/organism/Breadcrumbs';

export default function RevisionMenu() {
  const { slug } = useParams();

  return (
    <div className='flex h-[78px] w-full flex-row items-center justify-between bg-color-lightest py-5 shadow-level-1 xs:px-6 lg:px-[89px]'>
      <div className='flex flex-row items-center gap-lg'>
        <img
          src={Logo}
          className='xs:hidden xs:h-[24px] xs:w-[16.89px] md:h-[38px] md:w-[26.29px] lg:block'
          alt='Logo black'
        />
        <Breadcrumbs
          items={[
            { label: '', href: '' },
            { label: 'Cursos', href: '/cursos' },
            { label: 'Revisão', href: '#' },
          ]}
        />
      </div>
      <Typography type='title' size='h2'>
        Revisão
      </Typography>
      <Button allowReadOnly size='small' variant='text' asLink to={`/cursos/${slug}`}>
        Voltar para último conteúdo acessado no curso
      </Button>
    </div>
  );
}
